import path from 'path-browserify'
import store from '@/store'
import { ElMessage } from 'element-plus'
import useClipboard from 'vue-clipboard3'
const { toClipboard } = useClipboard()
export function deepClone(target) {
    // 定义一个变量
    let result
    // 如果当前需要深拷贝的是一个对象的话
    if (typeof target === 'object') {
        // 如果是一个数组的话
        if (Array.isArray(target)) {
            result = [] // 将result赋值为一个数组，并且执行遍历
            for (let i in target) {
                // 递归克隆数组中的每一项
                result.push(deepClone(target[i]))
            }
            // 判断如果当前的值是null的话；直接赋值为null
        } else if (target === null) {
            result = null
            // 判断如果当前的值是一个RegExp对象的话，直接赋值
        } else if (target.constructor === RegExp) {
            result = target
        } else {
            // 否则是普通对象，直接for in循环，递归赋值对象的所有值
            result = {}
            for (let i in target) {
                result[i] = deepClone(target[i])
            }
        }
        // 如果不是对象的话，就是基本数据类型，那么直接赋值
    } else {
        result = target
    }
    // 返回最终结果
    return result
}

function hasPermission(permission) {
    if (store.state.settings.enablePermission) {
        return store.state.user.permissions.some(v => {
            return v === permission
        })
    } else {
        return true
    }
}

export function auth(value) {
    let auth
    if (typeof value === 'string') {
        auth = hasPermission(value)
    } else {
        auth = value.some(item => {
            return hasPermission(item)
        })
    }
    return auth
}

export function authAll(value) {
    const auth = value.every(item => {
        return hasPermission(item)
    })
    return auth
}

export function isExternalLink(path) {
    return /^(https?:|mailto:|tel:)/.test(path)
}

export function resolveRoutePath(basePath, routePath) {
    if (isExternalLink(routePath)) {
        return routePath
    }
    if (isExternalLink(basePath)) {
        return basePath
    }
    return basePath ? path.resolve(basePath, routePath) : routePath
}

export function dateFormat(dateObj, format = 'YYYY-MM-DD hh:mm:ss') {
    dateObj = dateObj instanceof Date ? dateObj : new Date(dateObj)
    const date = {
        'Y+': dateObj.getFullYear(),
        'M+': dateObj.getMonth() + 1,
        'D+': dateObj.getDate(),
        'h+': dateObj.getHours(),
        'm+': dateObj.getMinutes(),
        's+': dateObj.getSeconds(),
        'q+': Math.floor((dateObj.getMonth() + 3) / 3),
        'S+': dateObj.getMilliseconds()
    }
    if (/(y+)/i.test(format)) {
        format = format.replace(RegExp.$1, (dateObj.getFullYear() + '').substr(4 - RegExp.$1.length))
    }
    for (const k in date) {
        if (new RegExp('(' + k + ')').test(format)) {
            format = format.replace(
                RegExp.$1,
                RegExp.$1.length === 1 ? date[k] : ('00' + date[k]).substr(('' + date[k]).length)
            )
        }
    }
    return format
}
/**
 * @description 有包含http的地址直接返回，没有的话添加上自己图片存储服务器的地址
 * @param {String} imgUrl 图片地址
 * @returns 计算后的图片地址
 */
export function calcImageUrl(imgUrl) {
    if (!imgUrl) return ''
    if (imgUrl.indexOf('http') === -1) {
        imgUrl = `${import.meta.env.VITE_APP_IMAGE_BASEURL}${imgUrl}`
    }
    return imgUrl
}

export async function copy(text, tip = '') {
    try {
        await toClipboard(text)
        ElMessage.success(`${tip}复制成功`)
    } catch (e) {
        console.error(e)
        ElMessage.error(`${tip}复制失败`)
    }
}
const getSelected = () => {
    if (window.getSelection) {
        // ie9以上及其他主流浏览器
        return window.getSelection().toString()
    } else {
        // ie9以下
        const selection = document.selection?.createRange()
        if (selection.text) {
            return selection.text.toString()
        }
        return ''
    }
}
/**
 * @description 点击表格中的APP跳转链接/小程序跳转链接
 */
export function clickTableJumpLink(row) {
    if (getSelected()) {
        console.log('用户选中文本中')
        return
    }
    row.enter = !row.enter
}

export function getElementLoadingSvg() {
    return `
    <path class="path" d="
    M 30 15
    L 28 17
    M 25.61 25.61
    A 15 15, 0, 0, 1, 15 30
    A 15 15, 0, 1, 1, 27.99 7.5
    L 15 15
    " style="stroke-width: 4px; fill: rgba(0, 0, 0, 0)"/>
    `
}
